<!--
  ~ Copyright (C) 2026 - Potentially Ltd
  ~
  ~ Please see distribution for license.
-->

<div
  class="v3-image-upload"
  [class.v3-image-upload--dragging]="isDragging()"
  [class.v3-image-upload--cropping]="isCropping"
  (dragover)="onDragOver($event)"
  (dragleave)="onDragLeave($event)"
  (drop)="onDrop($event)"
>
  <div class="v3-image-upload__header">
    <div class="v3-image-upload__heading">
      <h2 class="v3-image-upload__title subsection-title">{{ title() }}</h2>
      @if (isCropping) {
        <p class="v3-image-upload__description fs-body-s">{{ cropDescription }}</p>
      }
    </div>
    <button
      type="button"
      class="v3-image-upload__close"
      (click)="closeDialog()"
      [attr.aria-label]="'translations.global.ariaLabels.closeDialog' | transloco"
    >
      <ptl-icon [icon]="LucideX" [size]="'m'"></ptl-icon>
    </button>
  </div>

  <div class="v3-image-upload__body" [class.v3-image-upload__body--crop]="isCropping">
    @if (cropData(); as crop) {
      <ptl-v3-image-cropper
        [data]="crop"
        [cancelLabel]="backLabel"
        (applied)="onCropApplied($event)"
        (cancelled)="onCropCancelled()"
      ></ptl-v3-image-cropper>
    }

    <!-- Hidden rather than removed while cropping: stepping back lands on the same search results. -->
    <div class="v3-image-upload__pane" [class.v3-image-upload__pane--hidden]="isCropping">
      <ptl-v3-unsplash-search [initialPhrase]="initialSearchPhrase" (photoPicked)="onPhotoPicked($event)">
        <ptl-button
          searchAction
          class="v3-image-upload__upload-button"
          data-testid="image-dialog-browse"
          [type]="'primary'"
          [size]="'m'"
          [icon]="LucideUpload"
          [text]="'translations.imageUploadV3.uploadFile' | transloco"
          (clicked)="openFilePicker()"
        ></ptl-button>
      </ptl-v3-unsplash-search>
      <input
        data-testid="image-dialog-file"
        #fileInput
        type="file"
        class="v3-image-upload__file-input"
        [accept]="accept"
        (change)="onFileInputChange($event)"
      />
    </div>
  </div>

  @if (isDragging()) {
    <div class="v3-image-upload__drop-overlay">
      <span class="v3-image-upload__drop-icon">
        <ptl-icon [icon]="LucideArrowUp" [size]="'l'" [color]="'currentColor'"></ptl-icon>
      </span>
      <p class="v3-image-upload__drop-title fs-body-l bold">{{ 'translations.imageUploadV3.dropTitle' | transloco }}</p>
      <p class="v3-image-upload__drop-hint fs-body-s">
        {{ 'translations.imageUploadV3.dropHint' | transloco: { maxFileSizeMb: maxFileSizeMb } }}
      </p>
    </div>
  }
</div>
